var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'item',
    {
      isOther: _vm.isOthers(_vm.item),
      active: _vm.isActive(_vm.item),
      inActive: _vm.isInactive(_vm.item),
    } ],on:{"click":function($event){return _vm.$emit('toggleItem', _vm.item, true)}}},[_c('div',{staticClass:"item--rank"},[_vm._v(" "+_vm._s(_vm.item.RANK)+" ")]),_c('div',{staticClass:"item--label"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.item["QTY%"] + "%"))]),_c('span',{staticClass:"country"},[_vm._v(_vm._s(_vm.countryLabel(_vm.item)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }